const debounce = (func, wait) => {
  let timeout;

  return function (...args) {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      clearTimeout(timeout);
      func(...args);
    }, wait);
  };
};

const adjustTable = (id) => {
  const table = document.getElementById(id);

  if (!table) {
    return;
  }

  const headers = [...table.querySelectorAll('th')];
  const rows = [...table.querySelectorAll('tbody tr')];
  const priorities = headers.map((header, index) => ({
    index: index,
    priority: header.getAttribute('data-priority'),
  }));

  priorities.sort((a, b) => a.priority - b.priority);

  const availableWidth = table.parentNode.clientWidth;
  const totalWidth = headers.reduce((width, header) => width + header.offsetWidth, 0);

  let cumulativeWidth = 0;

  priorities.forEach((item) => {
    const header = headers[item.index];
    const isVisible = cumulativeWidth + header.offsetWidth <= availableWidth;

    if (isVisible) {
      header.style.display = '';
      rows.forEach((row) => {
        row.children[item.index].style.display = '';
      });
      cumulativeWidth += header.offsetWidth;
    } else {
      header.style.display = 'none';
      rows.forEach((row) => {
        row.children[item.index].style.display = 'none';
      });
    }
  });
};

window.setupAdjustTable = (id) => {
  window.addEventListener(
    'resize',
    debounce((e) => adjustTable(id), 100)
  );

  window.addEventListener('data-table-render', (e) => setTimeout(() => adjustTable(id), 1));
};
